export const seoConfig = {
  home: {
    title: "IT Monkeys - Architectures cloud & cybersécurité",
    description: "IT Monkeys - Société spécialisée en architectures cloud et cybersécurité, nous concevons, déployons et maintenons vos infrastructures cloud selon les plus hautes normes de sécurité."
  },
  cyberNews: {
    main: {
      title: "Actualités Cybersécurité - Veille technologique",
      description: "Restez informé des dernières actualités, vulnérabilités et innovations en cybersécurité avec notre veille technologique permanente."
    },
    exploits: {
      title: "Derniers Exploits Cybersécurité",
      description: "Veille complète sur les dernières exploitations de vulnérabilités et failles zero-day dans les systèmes informatiques."
    },
    cyberguerre: {
      title: "Actualités Cyberguerre et Cyberconflits",
      description: "Analyses et rapports sur les cyberconflits internationaux et les attaques entre états-nations."
    },
    quantique: {
      title: "Actualités Cryptographie Quantique",
      description: "Suivi des avancées en cryptographie post-quantique et impacts sur la sécurité informatique future."
    }
  },
  services: {
    main: {
      title: "Nos Services en Cybersécurité",
      description: "Audits, pentests, gestion de crise et solutions de sécurité sur mesure pour entreprises et institutions."
    },
    audit: {
      title: "Audits de Sécurité",
      description: "Audits complets de vos infrastructures avec remise de rapport détaillé et plan d'action priorisé."
    }
  },
  contact: {
    title: "Contactez nos Experts en Sécurité",
    description: "Prenez contact avec nos ingénieurs en cybersécurité pour une analyse de vos besoins en protection numérique."
  }
};

export type SeoConfig = typeof seoConfig; 